import Api from '@/api/api.js'

export default {
    getCertifications() {
        const promise = Api().get('/certifications')
        return promise.then((response) => response.data)
    },

    getTypesContrats() {
        const promise = Api().get('/type_contrats')
        return promise.then((response) => response.data)
    },

    getSecteurs() {
        const promise = Api().get('/secteurs')
        return promise.then((response) => response.data)
    },
    getSociete(id) {
        const promise = Api().get('/societe/' + id)
        return promise.then((response) => response.data)
    },
    
    //Enregistrer une societé
    saveSociete(data) {
        const promise = Api().post('/societe', data)
        return promise.then((response) => response.data)
    },

    //Liste des societés
    getSocietes() {
        const promise = Api().get('/societes')
        return promise.then((response) => response.data)
    },

    getDepartements(data) {
        const promise = Api().get('/departements', data)
        return promise.then((response) => response.data)
    },

    saveTravailleur(id,data) {
        const promise = Api().post('/societe/'+id+'/employes',data)
        return promise.then((response) => response.data)

    },

    deleteContrat(id) {
        const promise = Api().get('/societe/rompre_contrat/'+id)
        return promise.then((response) => response.data)

    },

    addContrat(data,id) {
        const promise = Api().post('/societe/ajout_contrat/'+id, data)
        return promise.then((response) => response.data)

    },

    //parametrage visites medicales 

    ajouterGroupeParametrageVM(data){
        const promise = Api().post('/societe/parametres/visites-medicales/groupes', data)
        return promise.then((response) => response.data)
    },

    getGroupeParametrageVM(id){
        const promise = Api().get('societe/'+id+'/parametres/visites-medicales/groupes')
        return promise.then((response) => response.data)
    },

    editGroupeParametrageVM(id,data){
        const promise = Api().put('societe/'+id+'/parametres/visites-medicales/groupes',data)
        return promise.then((response) => response.data)
    },

    deleteGroupeParametrageVM(societe_id,groupe_id){
        const promise = Api().delete('societe/'+societe_id+'/parametres/visites-medicales/groupes/'+groupe_id)
        return promise.then((response) => response.data)
    },

    getCategoriesVisitesMedicales(){
        const promise = Api().get('visites-medicales/categories')
        return promise.then((response) => response.data)
    },
    getSingleSubCategoryVM(id){
        const promise = Api().get('visites-medicales/sous-categories/'+id)
        return promise.then((response) => response.data)
    },
    checkIfVisiteMedicalesParamIsset(){
        const promise = Api().get('/visites-medicales/groupes/globaux-isset')
        return promise.then((response) => response.data)
    },
    programVisiteMedicale(data){
        const promise = Api().post('/visites-medicales', data)
        return promise.then((response) => response.data)
    },
    getVisitesMedicales(sous_categorie_id){
        const promise = Api().get('/visites-medicales?sous_categorie_id='+sous_categorie_id)
        return promise.then((response) => response.data)
    },
    searchVisitesMedicales(sous_categorie_id, societe_id,date )
    {
        const promise = Api().get('/visites-medicales/search?sous_categorie_id='+sous_categorie_id+'&societe_id='+societe_id+'&date='+date)
        return promise.then((response) => response.data)
    },

    initVisitesMedicalesProgrammation($societe_id,$data){
        const promise = Api().post("/visites-medicales/programmations/societes/"+$societe_id+"/init",$data);
        return  promise.then((response) =>response.data)
    },
    getSocieteCurrentVisiteMedicale($societe_id){
        const promise = Api().get("/visites-medicales/societes/current/"+$societe_id)
        return promise.then((response) => response.data)
    },
    getSocieteVisiteMedicaleStats(visite_id){
        const promise = Api().get("visites-medicales/"+visite_id+"/get-stats")
        return promise.then((response) => response.data)
    },
    getSocieteVisiteMedicaleStatsDone(visite_id){
        const promise = Api().get("visites-medicales/"+visite_id+"/get-stats/done")
        return promise.then((response) => response.data)
    },
    getProgrammationsVisitesMedicales(visite_id){
        const promise = Api().get("visites-medicales/"+visite_id+"/get-programmations")
        return promise.then((response) =>response.data)
    },
    importGlobalGroupesInSociete(id,data){
        const promise = Api().put("societe/"+id+"/parametres/visites-medicales/groupes/import",data)
        return promise.then((response) => response.data)
    },
    checkGroupeForEmployees(id,data){
        const promise = Api().post("visites-medicales/"+id+"/check-groupe",data)
        return promise.then((response) =>response.data )
    },
    searchProgrammationsVisitesMedicales(visite_id ,word_filter,departement_id,poste){
        const promise = Api().get("visites-medicales/"+visite_id+"/get-programmations?word_filter="+word_filter+"&departement_id="+departement_id+"&poste="+poste)
        return promise.then((response)=>response.data)
    },
    getPostes(id){
        const promise = Api().get("societe/"+id+"/postes")
        return promise.then((response)=>response.data)
    },
    getVisiteMedicaleResults(id){
        const promise = Api().get("visites-medicales/"+id+"/get-results")
        return promise.then((response)=>response.data)
    },
    uploadFileVisiteMedicale(id,data){
        const promise = Api().post("visites-medicales/programmations/"+id+"/upload-file",data)
        return promise.then((response)=>response.data)
    },
    getPostesSelect(){
        const promise = Api().get("postes")
        return promise.then((response)=>response.data)
    },

    getPendingVisitesForTechLabo(){
        const promise = Api().get("visites-medicales/laboratoire")
        return promise.then((response)=> response.data)
    },

    getProgrammationsForTechLabo(visite_id){
        const promise = Api().get("visites-medicales/laboratoire/"+visite_id)
        return promise.then((response)=> response.data)
    },

    sendVisitesAnalysesFiles(visite_id,analyse_id,data){
        const promise = Api().post("visites-medicales/"+visite_id+"/analyses/"+analyse_id+"/import",data)
        return promise.then((response) => response.data)
    },
    
    getVisitesForInfirmier(user_id){
        const promise = Api().get("visites-medicales/infirmier/"+user_id+"/board")
        return promise.then((response) => response.data)
    },
    getVisitesProgrammationsInfirmier(visite_id,user_id){
        const promise = Api().get('visites-medicales/'+visite_id+'/infirmier/'+user_id+'/board')
        return promise.then((response) => response.data)
    }
    
    
}